<template>
  <NavMenu
    app
    clipped
    :appName="appName"
    :menu="sidebar"
    :userInfo="user"
  />
</template>

<script>
import { computed, watch, onBeforeUnmount, onBeforeMount, ref } from 'vue'
import { NavMenu, useRenamePath, useVueRouter } from '@locaweb/design-system-vue'
import sidebarMenu from './sidebarMenu'
import { useSite } from '@/composables/api/useSite'
import { authStore } from '@/store/auth'
import { PROJECT_TITLE } from '@/consts'
import useCurrentSiteStore from '@/store/currentSite'
import useLayoutStore from '@/store/layout'
import { storeToRefs } from 'pinia'

export default {
  name: 'PanelLayout',
  components: {
    NavMenu
  },
  setup () {
    const { addPathName } = useRenamePath()
    const { $route, $router } = useVueRouter()

    const layoutStore = useLayoutStore()
    const currentSiteStore = useCurrentSiteStore()
    const { address } = storeToRefs(currentSiteStore)
    const { execute: executeFetch } = useSite()

    const user = computed(() => authStore().userInfo)
    const appName = computed(() => PROJECT_TITLE)
    const sidebar = ref(sidebarMenu())

    function onSuccess (data) {
      currentSiteStore.loadCurrentSite(data)
    }

    function onError (response) {
      const status = response?.status

      switch (status) {
        case 404:
          return $router.push({ name: 'not-found' })
        default:
          return $router.push('/')
      }
    }

    const siteId = $route.params.siteId

    watch(address, (newDomain) => {
      addPathName({ path: `/${siteId}`, name: newDomain })
    })

    onBeforeMount(async () => {
      layoutStore.setLoading(true)
      await executeFetch({ id: siteId, onSuccess, onError })
      layoutStore.setLoading(false)
    })

    onBeforeUnmount(() => currentSiteStore.$reset())

    return {
      user,
      appName,
      sidebar
    }
  }
}
</script>
